export const PUBLIC_URL = {
    url: 'https://soliterata.com',
    // url: 'https://preprod.soliterata.com',
}